import { createReducer, createSelector, on } from '@ngrx/store';
import { containerSearchInitiated } from './container.actions';
import dayjs from 'dayjs';
import { SearchDateOption } from './enum/SearchDateOption';

export interface IContainerSearchState {
    searchParams: { from: Date, to: Date, searchDateOption: SearchDateOption };
}

export const initialState: IContainerSearchState = {
    searchParams: {
        from: new Date(dayjs().add(1, 'day').subtract(7, 'days').format()),
        to: new Date(dayjs().add(1, 'day').format()),
        searchDateOption: SearchDateOption.SearchByVesselETAD
    }
};

export const ContainerSearchReducer = createReducer(
    initialState,
    on(containerSearchInitiated, (state, { searchParams }) => {
        const dateRangeIsUnchanged = dayjs(state.searchParams.from).isSame(searchParams.from, 'day')
            && dayjs(state.searchParams.to).isSame(searchParams.to, 'day')
            && state.searchParams.searchDateOption === searchParams.searchDateOption;

        if (dateRangeIsUnchanged) {
            return state;
        }

        return {
            ...state,
            searchParams
        };
    })
);

export const selectContainerSearchState = (state: any): IContainerSearchState =>  state.ContainerSearchState;

export const selectContainerSearch = createSelector(
    selectContainerSearchState,
    (state) => ({
        ...state.searchParams,
        searchDateOption: state.searchParams.searchDateOption ?? SearchDateOption.SearchByVesselETAD
    })
)
